
export class MemberRetailProgramSubscriptionModel {
    id:number;
    firstName: string;
    lastName: string;
    distributorId: string;
    memberId: number;
    emailAddress: string;
    retailLanguagesConfigID: number;
	retailLanguageLocale:string;
    periodsPurchased: number;
    enrollmentCreatedDate: string;
    enrollmentModifiedDate: string;
    createdDate: string;
    createdBy: number;
    updatedDate: string;
    updatedBy: string;
    rowStatus: number;
    businessEntityId?:string |number;
    addressDetailId?:string |number;
    vatId?:string
 }


// WEBPACK FOOTER //
// ./src/app/customerservice/interface/member-retail-program-subscription-model.ts